import { render, staticRenderFns } from "./message-details-action.vue?vue&type=template&id=4e66b221&"
import script from "./message-details-action.vue?vue&type=script&lang=js&"
export * from "./message-details-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports